module.exports = __webpack_public_path__ + "static/media/zoleLose_75_100.2fc4349c.png";